import {CurrentTask} from '../../types';

export const getAssignees = (tasks: Nullable<CurrentTask[]>): string[] => {
  if (!tasks?.length) {
    return [''];
  }

  return tasks.map(({assignee}) => `${assignee?.firstName || ''} ${assignee?.lastName || ''}`);
};
